var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v("Nearly there")]),_c('p',[_vm._v("That's all we need. If you're ready, you can submit your application now.")])])}]

export { render, staticRenderFns }